/**
 * Runtime detection — web (browser PWA) vs native (Capacitor APK).
 *
 * Por que precisa: o mesmo bundle JS roda em 2 ambientes muito diferentes:
 *  - Browser comum (Chrome/Safari) servido pelo Cloudflare Pages
 *  - WebView Android empacotado num APK Capacitor com plugins nativos
 *
 * Em native:
 *  - Storage de fotos: Filesystem nativo (não IndexedDB Blob)
 *  - Camera: plugin Capacitor (não getUserMedia)
 *  - Geolocation: plugin Capacitor (não navigator.geolocation)
 *  - API base: URL absoluta (não /api proxy do Pages)
 *  - Listeners adicionais: App.appStateChange, Network.networkStatusChange
 *
 * `window.Capacitor` é injetado pelo runtime do Capacitor antes do nosso JS rodar.
 * `isNativePlatform()` distingue web preview do app real.
 */

interface CapacitorGlobal {
  isNativePlatform?: () => boolean
  getPlatform?: () => 'web' | 'android' | 'ios'
}

function getCapacitor(): CapacitorGlobal | undefined {
  if (typeof window === 'undefined') return undefined
  return (window as Window & { Capacitor?: CapacitorGlobal }).Capacitor
}

/** True quando rodando dentro do WebView empacotado em APK/IPA. */
export function isNative(): boolean {
  const cap = getCapacitor()
  return cap?.isNativePlatform?.() === true
}

/** Granular: 'web' | 'android' | 'ios'. Default 'web'. */
export function getPlatform(): 'web' | 'android' | 'ios' {
  const cap = getCapacitor()
  if (!cap || cap.isNativePlatform?.() !== true) return 'web'
  return cap.getPlatform?.() ?? 'web'
}

/** True só em Android nativo. Útil pra mostrar UI Android-specific (botão de instalar, etc). */
export function isAndroid(): boolean {
  return getPlatform() === 'android'
}
